(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-banner-hover-element"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('.banner-hover-section');
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  sections.forEach((section) => {
    const imgEl = section.querySelector('.img-element');
    const textEl = section.querySelector('.text-heading');
    if (!imgEl && !textEl) return;

    let rafId = null;
    let lastEvent = null;

    function applyParallax(e) {
      const rect = section.getBoundingClientRect();

      const x = e.clientX - (rect.left + rect.width / 2);
      const y = e.clientY - (rect.top + rect.height / 2);

      const maxMove = 18;

      const nx = x / (rect.width / 2);
      const ny = y / (rect.height / 2);

      const cx = clamp(nx, -1, 1);
      const cy = clamp(ny, -1, 1);

      const moveX = cx * maxMove;
      const moveY = cy * maxMove;

      if (imgEl) imgEl.style.transform = `translate3d(${moveX}px, ${moveY}px, 0)`;
      if (textEl) textEl.style.transform = `translate3d(${moveX * 0.8}px, ${moveY * 0.8}px, 0)`;
    }

    section.addEventListener('mousemove', (e) => {
      lastEvent = e;
      section.classList.remove('is-leaving');

      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        applyParallax(lastEvent);
        rafId = null;
      });
    });

    section.addEventListener('mouseleave', () => {
      section.classList.add('is-leaving');

      if (imgEl) imgEl.style.transform = 'translate3d(0,0,0)';
      if (textEl) textEl.style.transform = 'translate3d(0,0,0)';

      // remove easing class after reset
      window.setTimeout(() => section.classList.remove('is-leaving'), 300);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-banner-slider"] && !Shopify.designMode) return;
  try {
    
  // Header scroll state (throttled)
  (function () {
    let last = 0;
    window.addEventListener('scroll', function () {
      const now = Date.now();
      if (now - last < 100) return;
      last = now;

      const header = document.querySelector('.header');
      if (!header) return;

      if (window.scrollY >= 100) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-tab-product-list"] && !Shopify.designMode) return;
  try {
    
    const tabsContainer = document.getElementById('tabs-container');
    const tabs = tabsContainer.querySelectorAll('.tab');
    const radios = tabsContainer.querySelectorAll('input[type=radio]');
    const glider = tabsContainer.querySelector('.glider');
    const tabItems = document.querySelectorAll('.tab-container-item');

    function moveGlider() {
        const selectedIndex = Array.from(radios).findIndex(r => r.checked);
        const activeTab = tabs[selectedIndex];
        const width = activeTab.offsetWidth;
        const x = activeTab.offsetLeft;

        glider.style.setProperty('--glider-width', width + 'px');
        glider.style.setProperty('--glider-x', x + 'px');
    }

    function switchTabs() {
        const selectedRadio = this;
        const tabId = selectedRadio.dataset.tabId;

        // First hide all tabs completely
        tabItems.forEach(item => {
            item.style.display = "none";
            item.style.opacity = 0;
            item.style.transition = "none"; // reset to avoid unwanted animation
        });

        // Then show the selected tab and fade it in
        const selectedItem = Array.from(tabItems).find(
            item => item.dataset.tabId === tabId
        );

        if (selectedItem) {
            selectedItem.style.display = "block";
            selectedItem.style.transition = "opacity 0.3s ease 0.1s";
            requestAnimationFrame(() => {
                selectedItem.style.opacity = 1;
            });
        }

        moveGlider();
    }

    moveGlider();


    radios.forEach(radio => {
        radio.addEventListener('change', switchTabs);
    });

    // Initialize on load
    window.addEventListener('load', moveGlider);
    window.addEventListener('resize', moveGlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"] && !Shopify.designMode) return;
  try {
    
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection) {
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        // Initialize Swiper for recommendation slider
        $('.product-recommendations .recommendation-slider').each(function () {
            let $section = $(this);
            let $sectionRecommendation = $('.product-recommendation-section');

            new Swiper(this, {
            slidesPerView: 4,
            spaceBetween: 15,
            allowTouchMove: true,
            loop: true,
            navigation: {
                nextEl: $sectionRecommendation.find('.float-nav .owl-next')[0],
                prevEl: $sectionRecommendation.find('.float-nav .owl-prev')[0],
            },
            breakpoints: {
                1524: {
                slidesPerView: 4,
                },
                1024: {
                slidesPerView: 4,
                },
                768: {
                slidesPerView: 2,
                },
                0: {
                slidesPerView: 2,
                },
            },
            });
        });
        })
        .catch(e => {
        console.error(e);
        });
    }


  } catch(e) { console.error(e); }
})();
})();
